/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Filter/Group/Active
 * @desc Active filter component for group
 */

import { ICONS } from 'labstep-web/constants/icons';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import { Group } from 'labstep-web/models/group.model';
import type React from 'react';
import type {
  GroupChildrenProps,
  LogFilterGroupActiveProps,
} from './types';

export const LogFilterGroupActive: React.FC<
  LogFilterGroupActiveProps
> = ({ clearParams, searchParams }) => (
  <>
    {'group_id' in searchParams && (
      <EntityReadEntityContainer
        entityName={Group.entityName}
        id={searchParams.group_id as number}
      >
        {({ entity: group }: GroupChildrenProps) => {
          return group ? (
            <RemoveLabel
              icon={ICONS.group.primary}
              name={`${group.name}`}
              onRemoveClick={
                clearParams && (() => clearParams(['group_id']))
              }
            />
          ) : null;
        }}
      </EntityReadEntityContainer>
    )}
  </>
);
